import joinUrl from '../utils/join-url';
import requestUtility from '../helpers/request-utility';
import credentials from '../constants/credentials';

const PUBLIC_API_GATEWAY_ENDPOINT = '/checkoutservice/pb/products/prices/';
const LEGACY_ENDPOINT = '/productservice/v2/purchasable-product-types/';

const productsTree = (apiUrl) => (options, query) => {
  if (apiUrl) {
    const url = joinUrl(apiUrl, PUBLIC_API_GATEWAY_ENDPOINT);

    return requestUtility.get(url, query, credentials.INCLUDE);
  } else {
    return requestUtility.get(LEGACY_ENDPOINT, query, credentials.SAME_ORIGIN);
  }
};

export default productsTree;
